import { useState } from 'react';

// Field errors appear after blur, after the step's Continue is pressed, or from the server.
export default function useFieldErrors() {
  const [touched, setTouched] = useState({});
  const [attempted, setAttempted] = useState({});
  const [serverErrors, setServerErrors] = useState({});

  const visibleErrors = (all, stepKey) => {
    const out = {};
    Object.keys(all).forEach((k) => { if (attempted[stepKey] || touched[k]) out[k] = all[k]; });
    Object.keys(serverErrors).forEach((k) => { if (serverErrors[k]) out[k] = serverErrors[k]; });
    return out;
  };

  return {
    visibleErrors,
    handleBlur: (e) => setTouched((prev) => ({ ...prev, [e.target.name]: true })),
    markAttempted: (stepKey) => setAttempted((prev) => ({ ...prev, [stepKey]: true })),
    setServerError: (field, message) => setServerErrors({ [field]: message }),
    clearServerError: (field) => {
      if (serverErrors[field]) setServerErrors((prev) => ({ ...prev, [field]: undefined }));
    },
  };
}
